import { memo, Dispatch, SetStateAction } from 'react';
import Table from 'ui/molecules/Table';
import { TabIndex, TabProps } from 'ui/organizms/Consumers/ConsumerDialogs/MultiTabDialog/types';
import { DuplicateEmailsTableBody, DuplicateEmailsTableHead } from './DuplicateEmailsTable';
import useDuplicateEmailsList from './useDuplicateEmailsList';

type Props = TabProps<TabIndex.ManageDuplicates> & {
    readonly requestLoading: [boolean, Dispatch<SetStateAction<boolean>>]
};

const DuplicateEmails = (props: Props) => {
    useDuplicateEmailsList(props);

    const {
        tabRegistry: [manageDuplicatesRegistry],
        requestLoading: [isLoading]
    } = props;
    const manageDuplicatesDataRegistry = manageDuplicatesRegistry ?? [];

    const normalizedProps = {
        ...props,
        tabRegistry: [
            manageDuplicatesDataRegistry,
            props.tabRegistry[1]
        ] as Props['tabRegistry']
    };

    return (
        <Table
            isLoading={isLoading}
            isEmpty={manageDuplicatesDataRegistry.length === 0}
            emptyMessageSlot="No duplicates found"
        >
            <DuplicateEmailsTableHead />
            <DuplicateEmailsTableBody
                {...normalizedProps}
            />
        </Table>
    );
};

export default memo(DuplicateEmails);
